import { render } from "./index.vue?vue&type=template&id=88ab13ae"
import script from "./fourth.js?vue&type=script&lang=js&external"
export * from "./fourth.js?vue&type=script&lang=js&external"

import "./fourth.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__